// extracted by mini-css-extract-plugin
export var filterButton = "_pg-1";
export var filtersContainer = "_pg-0";